// removed by extract-text-webpack-plugin
module.exports = {"testimonials-section":"src-components----TestimonialsSection-module---testimonials-section---1It4_","headers":"src-components----TestimonialsSection-module---headers---29pAz","cell-wrapper":"src-components----TestimonialsSection-module---cell-wrapper---3fOvo","quote":"src-components----TestimonialsSection-module---quote---2sJQf","attribution":"src-components----TestimonialsSection-module---attribution---3xutK","name":"src-components----TestimonialsSection-module---name---2nFm8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TestimonialsSection.module.scss
// module id = 664
// module chunks = 168707334958949